import { render, staticRenderFns } from "./VerifyPhoneDialog.vue?vue&type=template&id=02d25422&scoped=true"
import script from "./VerifyPhoneDialog.vue?vue&type=script&lang=ts"
export * from "./VerifyPhoneDialog.vue?vue&type=script&lang=ts"
import style0 from "./VerifyPhoneDialog.vue?vue&type=style&index=0&id=02d25422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d25422",
  null
  
)

export default component.exports